import React from 'react';

/**
 * Calm marketplace page intro — one job: title + short support line.
 */
const MarketingBrowseHeader = ({
  eyebrow = null,
  title,
  description = null,
  countLabel = null,
  className = '',
}) => {
  return (
    <header className={`mb-8 hidden md:block md:mb-10 ${className}`.trim()}>
      {eyebrow ? (
        <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-m-ink-muted">
          {eyebrow}
        </p>
      ) : null}
      <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
        <div className="min-w-0 max-w-xl">
          <h1 className="marketing-section-title mb-2 text-m-ink md:mb-3">
            {title}
          </h1>
          {description ? (
            <p className="max-w-md text-[15px] leading-relaxed text-m-ink-muted">
              {description}
            </p>
          ) : null}
        </div>
        {countLabel ? (
          <p className="shrink-0 text-sm text-m-ink-muted">{countLabel}</p>
        ) : null}
      </div>
    </header>
  );
};

export default MarketingBrowseHeader;
